<template>
  <div>
    <div v-if="partner != null" id="show-partner">
      <v-row>
        <v-col cols="12">
          <v-card class="mt-3">
            <v-card-title>
              {{ partner.name }}
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6">
                  <div>
                    Identifiant :
                    <span class="font-weight-bold">
                      {{ partner.technicalId }}
                    </span>
                  </div>
                  <div>
                    SMTP par défaut :
                    <span class="font-weight-bold">
                      {{ partner.defaultSmtp }}
                    </span>
                  </div>
                </v-col>
                <v-col cols="12" sm="6">
                  <div>
                    Serveur web n°1 :
                    <span class="font-weight-bold">
                      {{ partner.fqdnFrontend1 }}
                    </span>
                  </div>
                  <div>
                    Serveur web n°2 :
                    <span class="font-weight-bold">
                      {{ partner.fqdnFrontend2 }}
                    </span>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xl="6">
          <portal-profile-card :partner="partner"></portal-profile-card>
        </v-col>
        <v-col cols="12" xl="6">
          <profile-card :partner="partner"></profile-card>
        </v-col>
        <v-col cols="12" xl="6">
          <attribute-card :partner="partner"></attribute-card>
        </v-col>
        <v-col cols="12" xl="6">
          <card-model-card :partner="partner"></card-model-card>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <LoadingDialog />
    </div>
  </div>
</template>
<script>
import { onMounted, toRefs } from "@vue/composition-api";
import router from "../router";
import { usePartner } from "../composables/partner";
import PortalProfileCard from "../components/Partner/PortalProfileCard";
import ProfileCard from "@/components/Partner/ProfileCard";
import AttributeCard from "@/components/Partner/AttributeCard";
import CardModelCard from "@/components/Partner/CardModelCard";
import { useTitle } from "@/composables/title";
import LoadingDialog from "@/components/General/LoadingDialog.vue";

export default {
  components: {
    CardModelCard,
    AttributeCard,
    ProfileCard,
    PortalProfileCard,
    LoadingDialog,
  },
  setup() {
    const { setTitle } = useTitle();

    const { partnerData, showPartner } = usePartner();
    const partnerId = router.currentRoute.params.id;
    onMounted(async () => {
      await showPartner(partnerId);
      setTitle("Partenaire - " + partnerData.partner.name);
    });

    return {
      ...toRefs(partnerData),
    };
  },
};
</script>
